exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".skillBoxes{border-top:15px solid #67cea3!important}", ""]);

// exports
